import React, { FC, useMemo } from 'react';

import {
	EvComboboxOption,
	EVINCED_SEVERITIES,
	EvSelectNew,
	EvSwitch,
	EvTitle
} from '@evinced-private/ui-common';

import { resolveTenantWideSeverityLabel } from '../../../../helpers/SeverityLabelHelper';
import { useDashboard } from '../../../../providers/dashboard/DashboardProvider';
import { buildPropertiesInfoSortOptions } from '../../DashboardConsts';
import { TSortOption } from '../../DashboardTypes';
import { VerticalSeparator } from '../kpis/VerticalSeparator';

import './TopImpactPropertiesHeader.scss';

interface ITopImpactPropertiesHeader {
	withViews: boolean;
	onWithViewsChange: (isWithView: boolean) => void;
	sortBy: TSortOption;
	onSortByChange: (sortOption: TSortOption) => void;
}

const tableTitle = 'Highlighted properties';
const TopImpactPropertiesHeader: FC<ITopImpactPropertiesHeader> = ({
	withViews,
	onWithViewsChange,
	sortBy,
	onSortByChange
}) => {
	const { customSeverityNamesByPropertyId } = useDashboard();

	const criticalLabel = useMemo(
		() =>
			resolveTenantWideSeverityLabel(EVINCED_SEVERITIES.CRITICAL, customSeverityNamesByPropertyId),
		[customSeverityNamesByPropertyId]
	);

	const tableTooltip = useMemo(
		() =>
			`The properties that showed the largest change in percentage, ${criticalLabel.toLowerCase()} issues, and/or pages scanned within the selected time period.`,
		[criticalLabel]
	);

	const sortOptions = useMemo(() => buildPropertiesInfoSortOptions(criticalLabel), [criticalLabel]);

	return (
		<div className="top-impact-properties-header">
			<EvTitle
				titleText={tableTitle}
				MoreInfoContent={<div>{tableTooltip}</div>}
				headingLevel={3}
				className="title-header"
			/>
			<div className="update-actions">
				<EvSwitch
					onChange={onWithViewsChange}
					checked={withViews}
					label="Include Views"
					className="include-views"
				/>
				<VerticalSeparator className="sort-actions-separator" />
				<div className="sort-by-selection">
					<EvSelectNew
						id="top-impact-properties-sort"
						options={sortOptions}
						selectedValue={[sortBy as unknown as EvComboboxOption]}
						onSelectChange={(selected) => {
							onSortByChange(selected[0] as unknown as TSortOption);
						}}
						placeholder="Sort by"
						label="Sort by"
						labelPosition="left"
					/>
				</div>
			</div>
		</div>
	);
};

export { TopImpactPropertiesHeader };
